import { IonText, IonToggle } from '@ionic/react';

import { mergeClassNames } from '@/utils';

import styles from './index.module.css';

interface IInputSwitchProps {
  disabled?: boolean;
  label: string;
  onIonChange?: (event: CustomEvent) => void;
  checked?: boolean;
}

export const InputSwitch = ({ disabled = false, label, onIonChange, checked }: IInputSwitchProps) => {
  return (
    <div className={styles.container}>
      <IonToggle aria-label={label} checked={checked} disabled={disabled} onIonChange={onIonChange} />
      <IonText className={mergeClassNames(styles.label, disabled && styles.disabled)}>{label}</IonText>
    </div>
  );
};
